import React from 'react';

/**
 * BrandLogo — the official Diamond Scorer mark.
 *
 * Two flavors:
 *   <BrandLogo size={48} />                       → just the 3D DS monogram
 *   <BrandLogo size={48} withWordmark />          → monogram + "Diamond Scorer" lockup
 *   <BrandLogo size={48} withWordmark variant="dark" /> → for light backgrounds
 *
 * The image asset lives at /diamond-scorer-logo.jpg (public folder) — it's the
 * user-supplied 3D emerald + gold logo. Loaded eagerly because it's part of
 * the masthead on nearly every page and we want zero LCP delay.
 */
export const BrandLogo = ({ size = 36, withWordmark = false, variant = 'light', className = '' }) => {
  const isDark = variant === 'dark';
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img
        src="/diamond-scorer-logo.jpg"
        alt="Diamond Scorer"
        width={size}
        height={size}
        loading="eager"
        decoding="async"
        style={{
          width: size,
          height: size,
          borderRadius: Math.round(size * 0.18),
          // Soft emerald glow that matches the logo's atmosphere
          boxShadow: '0 0 12px rgba(46, 190, 107, 0.35), 0 1px 3px rgba(0,0,0,0.4)',
          objectFit: 'cover',
          flexShrink: 0,
        }}
      />
      {withWordmark && (
        <span
          className="font-bold tracking-tight uppercase leading-none"
          style={{
            fontFamily: 'Barlow Condensed, sans-serif',
            fontSize: Math.round(size * 0.62),
            color: isDark ? '#0A1322' : '#FFFFFF',
            letterSpacing: '0.5px',
          }}
        >
          <span style={{ color: '#1FA85A' }}>Diamond</span>
          <span style={{ color: '#D4A03A', marginLeft: 4 }}>Scorer</span>
        </span>
      )}
    </div>
  );
};

export default BrandLogo;
